/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";

export class OptionViewer extends BaseFieldViewer {
	@autobind
	_render() {
		const {Value, FieldDef} = this.props;

		if (FieldDef?.customData) {
			if (FieldDef?.customData[Value]) {
				return FieldDef?.customData[Value];
			}
		}

		return Value ? "Yes" : "No";
	}
}